export default __webpack_public_path__ + "static/media/confirmpurchase.4f057300.jpg";